import { render, staticRenderFns } from "./RelationFieldAddCaseDialog.vue?vue&type=template&id=3a691622"
import script from "./RelationFieldAddCaseDialog.vue?vue&type=script&lang=js"
export * from "./RelationFieldAddCaseDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports